<template>
  <div>

    <BackButton v-if="$route.name !== 'parkings'" :namedRoutes="{ parkings: $t('nav.parkings'), parking: $t('parking.parking')}"></BackButton>

    <add-parking-view v-if="$route.name === 'edit-parking' || $route.name === 'add-parking'" />
    <parking-details v-if="$route.name === 'parking'" />

    <BackButton v-if="$route.name !== 'parkings'" :namedRoutes="{ parkings: $t('nav.parkings'), parking: $t('parking.parking')}"></BackButton>

  </div>
</template>

<script>
import BackButton from 'common/BackButton';
import ParkingDetails from 'parkings/ParkingDetails';
import AddParkingView from './AddParkingView';

export default {
  components: {
    BackButton,
    ParkingDetails,
    AddParkingView,
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/parkings/MainView.vue